import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'paetep-reset-button',
    templateUrl: './paetep-reset-button.component.html',
    styleUrls: ['./paetep-reset-button.component.scss']
})
export class PaetepResetButtonComponent {
    @Input() isBusy: boolean = false;
    @Input() isDisabled: boolean = false;

    @Output() onClick = new EventEmitter<any>();

    constructor() { }

    onResetButtonClicked = () => {
        this.onClick.emit();
    } 
}
